module.exports = __webpack_public_path__ + "img/default_asphalted.f325836d.png";